import { Button, Col, Icon, Row, Tooltip, Input } from 'antd';
import classNames from 'classnames/bind';
import { CardContainer } from 'components/ui/index';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import styles from '../index.less';
import { addToSelection, removeFromSelection, setNewOrder, setIsDefaultField, resetFilterValue } from './flow/actions';
import { resetView } from '../../flow/actions';

const cx = classNames.bind(styles);
const { Search } = Input;

const propTypes = {
  intl: intlShape.isRequired,
  availableFields: PropTypes.array.isRequired,
  selectedFields: PropTypes.array.isRequired,
  colLayout: PropTypes.object,
  rowLayout: PropTypes.object,
  cardCustomClass: PropTypes.string,
  NeedRestriction: PropTypes.bool,
};

const defaultProps = {
  colLayout: {
    xs: 24,
    sm: 10,
  },
  rowLayout: {},
  cardCustomClass: '',
  NeedRestriction: true,
};

class FieldsSelection extends Component {
  state = {
    selectedFields: [],
    leftSearchKey: '',
  }

  componentWillUnmount() {
    const { resetView, resetFilterValue } = this.props;
    resetView();
    resetFilterValue();
  }

  onSelectIds = selectedFields => this.setState({ selectedFields })

  addToSelection = () => {
    const { addToSelection, setIsDefaultField } = this.props;
    addToSelection(this.state.selectedFields);
    // setIsDefaultField is used to check if user change any thing in the modal;
    setIsDefaultField(false);
  }

  removeFromSelection = () => {
    const { removeFromSelection, setIsDefaultField } = this.props;
    removeFromSelection(this.state.selectedFields, this.props.NeedRestriction);
    // setIsDefaultField is used to check if user change any thing in the modal;
    setIsDefaultField(false);
  }

  // TODO: Add new prop passing to CardContainer in order to disable the sorting
  handleDropInAvailable = () => { }

  handleDropInSelection = sortedArray => {
    const { setNewOrder, setIsDefaultField } = this.props;
    setNewOrder(sortedArray);
    // setIsDefaultField is used to check if user change any thing in the modal;
    setIsDefaultField(false);
  }

  handleLeftSearchChange = async e => {
    e.preventDefault();
    this.setState({ leftSearchKey: e.target.value });
    this.filterAvailableFields();
  }

  filterAvailableFields = () => {
    const { availableFields } = this.props;
    const { leftSearchKey } = this.state;
    const filterFields = availableFields.filter(field => field.field_label.toLowerCase().indexOf(leftSearchKey.toLowerCase()) > -1);
    return filterFields;
  }

  render() {
    const {
      intl,
      theme,
      availableFields,
      selectedFields,
      colLayout,
      rowLayout,
      cardCustomClass,
      NeedRestriction,
      needSearchBar,
      isFilterModal
    } = this.props;
    const { formatMessage } = intl;
    const i18n = 'page.objectFilter.selectors.sectionTitles';

    const cardTitle = (
      <Fragment>
        {formatMessage({ id: `${i18n}.selected` })}
        <Tooltip title={formatMessage({ id: 'global.ui.dialog.multipleDnd' })}>
          <Icon className="font-sm ml-sm" type="info-circle-o" />
        </Tooltip>
      </Fragment>
    );

    const leftCardAction = (
      <Search
        key="searchBar"
        className="full-width"
        onChange={this.handleLeftSearchChange}
      />
    );

    return (
      <Row {...rowLayout}>
        <Col {...colLayout}>
          <CardContainer
            title={formatMessage({ id: `${i18n}.available` })}
            titleAction={needSearchBar ? leftCardAction : null}
            data={needSearchBar && availableFields ? this.filterAvailableFields() : availableFields}
            theme={theme}
            onSelect={this.onSelectIds}
            onDrop={this.handleDropInAvailable}
            cardCustomClass={cardCustomClass}
            cardDisplayField="field_label"
            NeedRestriction={NeedRestriction}
            isFilterModal={isFilterModal}
          />
        </Col>
        <Col sm={2} xs={24} className={cx('moveBtnContainer')} >
          <Button className={cx('moveBtn')} onClick={this.addToSelection}>
            <Icon type="arrow-right" size="small" />
          </Button>
          <br />
          <Button className={cx('moveBtn')} onClick={this.removeFromSelection}>
            <Icon type="arrow-left" size="small" />
          </Button>
        </Col>
        <Col {...colLayout}>
          <CardContainer
            title={cardTitle}
            data={selectedFields}
            theme={theme}
            onSelect={this.onSelectIds}
            onDrop={this.handleDropInSelection}
            cardCustomClass={cardCustomClass}
            cardDisplayField="field_label"
            NeedRestriction={NeedRestriction}
          />
        </Col>
      </Row>
    );
  }
}


FieldsSelection.propTypes = propTypes;
FieldsSelection.defaultProps = defaultProps;
const mapStateToProps = ({ global, objectView }) => ({
  language: global.language,
  availableFields: objectView.fields.availableFields,
  selectedFields: objectView.fields.selectedFields,
});
const mapDispatchToProps = {
  addToSelection,
  removeFromSelection,
  setNewOrder,
  resetView,
  setIsDefaultField,
  resetFilterValue,
};
export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(FieldsSelection));



// WEBPACK FOOTER //
// ./src/components/page/ObjectFilter/components/FieldsSelection/index.jsx